export default __webpack_public_path__ + "static/media/job_details_img.ade1ba42.svg";